import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { FeatureFlagsEditor } from '../components/FeatureFlagsEditor';
import { EmailSettingsForm } from '../components/EmailSettingsForm';
import { StripeConfigCard } from '../components/StripeConfigCard';
import { OpenPayeConfigCard } from '../components/OpenPayeConfigCard';

export function PlatformSettingsPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div><h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Configuration</h1><p className="text-sm text-neutral-500">Paramètres de la plateforme</p></div>
        <Link to="/settings/audit-log"><Button variant="outline" size="sm">Journal d'audit</Button></Link>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <StripeConfigCard />
        <OpenPayeConfigCard />
      </div>

      <FeatureFlagsEditor />
      <EmailSettingsForm />
    </div>
  );
}
